import { Component, OnInit, AfterViewInit, Input, AfterViewChecked } from '@angular/core';
import { PlotlyService } from '../plotly-graph/plotly.service';
import { EndpointService } from '@app/endpoint/endpoint.service';
import { TestCaseService } from '@app/testcase/testcase.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: "app-mobile-performance-graph",
  templateUrl: "./mobile-performance-graph.component.html",
  styleUrls: ["./mobile-performance-graph.component.less"],
})
export class MobilePerformanceGraphComponent implements  OnInit,AfterViewInit {
  @Input() mostRecentExecuted: any;
  @Input() parentIndex: any;
  @Input() type: any;
  activeTabId: any = 0;
  graphData: any;
  showErrorDiv = false;
  errorMessage = '';

  constructor(private plot: PlotlyService, private endpointService: EndpointService, private testcaseService: TestCaseService,
    private toastr: ToastrService
  ) {}

  ngOnInit(): void {
    if(this.type == "ENDPOINT") {
      this.getEndpointMobilePerformanceGraph(this.mostRecentExecuted.endPointExecution[this.parentIndex].noSqlId);
    } else if(this.type == "TESTCASE") {
      this.getTestcaseMobilePerformanceGraph(this.mostRecentExecuted.noSqlId);
    } else if(this.type == "TESTSUITE") {
      this.getTestcaseMobilePerformanceGraph(this.mostRecentExecuted.noSqlId);
    }
  }

  ngAfterViewInit() {
    if (this.activeTabId === 0) {
      // Ensure the plot element is available before interacting with it
      const plotBarElement = document.getElementById('plot-line-scatter1');
      if (plotBarElement) {
        setTimeout(() => {
          this.generateCumulativeWithoutWaitTime(this.graphData.CUMULATIVE_WITHOUT_WAIT_TIME);
        }, 1000);
      }
    }
  }

  // Update activeTabId to change tabs
  changeTab(event: any) {
    if(event.nextId == 0) {
      setTimeout(() => {
        this.generateCumulativeWithoutWaitTime(this.graphData.CUMULATIVE_WITHOUT_WAIT_TIME);
      }, 200);
    } else if(event.nextId == 1) {
      setTimeout(() => {
        this.generateSimplePerformanceGraph(this.graphData.SIMPLE);
      }, 200);
    } else if(event.nextId == 2) {
      setTimeout(() => {
        this.generateSimpleWithoutWaitTimeGraph(this.graphData.SIMPLE_WITHOUT_WAIT_TIME);
      }, 200);

    }
  }

  getEndpointMobilePerformanceGraph(executionId: any) {
      this.endpointService.getEndpointMobilePerformanceGraph(executionId).pipe().subscribe(data => {
        if (data.code === 200) {
          this.graphData = data.response;
          console.log(data)
        } else {
          // this.toastr.error(data.message);
          this.showErrorDiv = true;
          this.errorMessage = data.message;
        }
      });
  }

  getTestcaseMobilePerformanceGraph(executionId: any) {
    this.testcaseService.getTestcaseMobilePerformanceGraph(executionId).pipe().subscribe(data => {
      if (data.code === 200) {
        this.graphData = data.response;
        console.log(data)
      } else {
        // this.toastr.error(data.message);
        this.showErrorDiv = true;
        this.errorMessage = data.message;
      }
    });
}


  generateSimplePerformanceGraph(data: any) {
    this.plot.generateSimpleMobilePerformanceGraph(data.graph_name, 'plot-bar', data.x, data.y, data.x_label, data.y_label, data.info)
  }

  generateSimpleWithoutWaitTimeGraph(data: any) {
    this.plot.generateMobileSimpleWithoutWaitTimeGraph(data.graph_name, 'plot-line-scatter', data.x, data.y, data.x1, data.y1, data.x_label, data.y_label, data.info, data.info1)
  }

  generateCumulativeWithoutWaitTime(data: any) {
    this.plot.generateMobileCumulativeWithoutWaitTime(data.graph_name, 'plot-line-scatter1', data.x, data.y, data.x1, data.y1, data.x_label, data.y_label, data.info, data.info1)
  }
}
